import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { updateCustomer, customerUpdated } from '../../actions/company';
import NavBarConfig from '../../components/NavBarConfig';
import CustomerUpdate from './components/CustomerUpdate';

const messages = defineMessages({
  BACK: {
    id: 'AllUsers.BACK',
    defaultMessage: 'Zurück',
  },
  EDIT_CUSTOMER: {
    id: 'CustomerUpdatePage.EDIT_CUSTOMER',
    defaultMessage: 'Kunde bearbeiten',
  },
  DELETE_MESSAGE: {
    id: 'CustomerUpdatePage.DELETE_MESSAGE',
    defaultMessage: 'Kunde löschen',
  },
});

function CustomerUpdatePage({
  company,
  customer,
  routes,
  onSubmit,
  intl: { formatMessage },
}) {
  if (!customer) { return null; }
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig updatePage currentRouteName={routes[routes.length - 1].name} />
      
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={`/company/${company.id}/customer/`} onMouseDown={e => e.preventDefault()} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <div>
              <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                {formatMessage(messages.EDIT_CUSTOMER)}
              </h2>
            </div>
          </div>

          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
          <CustomerUpdate onSubmit={onSubmit} initialValues={customer} />

          <div style={{ borderTop: '1px solid var(--panel-border)', paddingTop: '24px', marginTop: '40px' }}>
            <Link
              className="lh-btn lh-btn-block"
              style={{ marginTop: '24px', backgroundColor: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
              to={`/company/${company.id}/customer/${customer.id}/delete/`}
            >
              <span className="fa fa-trash" /> {formatMessage(messages.DELETE_MESSAGE)}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default connect(null,
  (dispatch, { params }) => ({
    onSubmit: formData => updateCustomer(params.companyId, params.customerId, formData).then(
      (customer) => {
        dispatch(customerUpdated(customer));
        dispatch(push(`/company/${params.companyId}/customer/${params.customerId}/`));
      }
    ),
  }),
)(injectIntl(CustomerUpdatePage));
